import { __assign, __rest, __makeTemplateObject } from 'tslib';
import React__default, { createElement, useRef, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import useDimensions from 'react-use-dimensions';

var Play = function Play(props) {
  return React__default.createElement("svg", __assign({
    viewBox: "0 0 1.25 1.25",
    display: "block"
  }, props), React__default.createElement("path", {
    fill: "currentColor",
    d: "M.25.125l1 .5-1 .5z"
  }));
};

var Pause = function Pause(props) {
  return React__default.createElement("svg", __assign({
    viewBox: "0 0 1 1",
    display: "block"
  }, props), React__default.createElement("g", {
    fill: "currentColor"
  }, React__default.createElement("path", {
    d: "M.15.15h.262v.7H.15zM.588.15H.85v.7H.588z"
  })));
};

var SkipBack = function SkipBack(_a) {
  var seconds = _a.seconds,
      rest = __rest(_a, ["seconds"]);

  return React__default.createElement("svg", __assign({
    viewBox: "0 0 71 71"
  }, rest), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "prefix__a"
  }, React__default.createElement("path", {
    d: "M.5 71.5V.5h71v71z"
  }))), React__default.createElement("g", {
    clipPath: "url(#prefix__a)",
    transform: "matrix(-1 0 0 1 71 0)"
  }, React__default.createElement("path", {
    d: "M61.5 35.5c0 7-2 14-8 20-10 11-28 11-39 0-10-11-10-28 0-39 6-6 14-8 21-8h1",
    fill: "none",
    strokeWidth: 3,
    stroke: "currentColor",
    strokeLinecap: "square"
  }), React__default.createElement("path", {
    d: "M61.5 35.5h-6M12.5 35.5h-6M34.5 57.5v6",
    fill: "none",
    strokeWidth: 3,
    stroke: "currentColor"
  }), React__default.createElement("path", {
    d: "M34 1l11 7-11 7v-1V0zM45 1l12 7-12 7v-1V0z",
    fill: "currentColor"
  })), React__default.createElement("text", {
    x: 23,
    y: 44,
    fontSize: 23,
    fill: "currentColor",
    className: "prefix__svgcentertext"
  }, seconds));
};

var SkipForward = function SkipForward(_a) {
  var seconds = _a.seconds,
      rest = __rest(_a, ["seconds"]);

  return React__default.createElement("svg", __assign({
    viewBox: "0 0 71 71"
  }, rest), React__default.createElement("defs", null, React__default.createElement("clipPath", {
    id: "prefix__a"
  }, React__default.createElement("path", {
    d: "M.5 71.5V.5h71v71z"
  }))), React__default.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, React__default.createElement("path", {
    d: "M61.5 35.5c0 7-2 14-8 20-10 11-28 11-39 0-10-11-10-28 0-39 6-6 14-8 21-8h1",
    fill: "none",
    strokeWidth: 3,
    stroke: "currentColor",
    strokeLinecap: "square"
  }), React__default.createElement("path", {
    d: "M61.5 35.5h-6M12.5 35.5h-6M34.5 57.5v6",
    fill: "none",
    strokeWidth: 3,
    stroke: "currentColor"
  }), React__default.createElement("path", {
    d: "M34 1l11 7-11 7v-1V0zM45 1l12 7-12 7v-1V0z",
    fill: "currentColor"
  })), React__default.createElement("text", {
    x: 22,
    y: 44,
    fontSize: 23,
    fill: "currentColor",
    className: "prefix__svgcentertext"
  }, seconds));
};

var ProgressBar = function ProgressBar(_a) {
  var background = _a.background,
      completeBackground = _a.completeBackground,
      color = _a.color,
      seek = _a.seek,
      total = _a.total,
      value = _a.value,
      size = _a.size;
  var element = React__default.useRef(null);
  return React__default.createElement(Container, {
    ref: element,
    color: background,
    style: {
      height: size,
      minHeight: size
    }
  }, React__default.createElement(Progress, {
    value: value,
    max: total || 0,
    background: background,
    completeBackground: completeBackground
  }), React__default.createElement(Slider, {
    value: value,
    max: total || 0,
    color: color,
    size: size,
    onChange: function onChange(event) {
      return seek(Number(event.target.value));
    }
  }));
};

var Container = /*#__PURE__*/styled.div(templateObject_1 || (templateObject_1 = /*#__PURE__*/__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var fullWidth = /*#__PURE__*/css(templateObject_2 || (templateObject_2 = /*#__PURE__*/__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  height: 100%;\n"])));

var progressStyles = function progressStyles(_a) {
  var completeBackground = _a.completeBackground;
  return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  background-color: ", ";\n"], ["\n  background-color: ", ";\n"])), completeBackground);
};

var Progress = /*#__PURE__*/styled.progress(templateObject_4 || (templateObject_4 = /*#__PURE__*/__makeTemplateObject(["\n  ", "\n  background-color: ", ";\n  box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.3);\n  &[value]::-webkit-progress-value {\n    ", "\n  }\n  &[value]::-moz-progress-value {\n    ", "\n  }\n  &[value]::-webkit-progress-bar {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n  background-color: ", ";\n  box-shadow: inset 1px 1px 2px rgba(0, 0, 0, 0.3);\n  &[value]::-webkit-progress-value {\n    ", "\n  }\n  &[value]::-moz-progress-value {\n    ", "\n  }\n  &[value]::-webkit-progress-bar {\n    background-color: ", ";\n  }\n"])), fullWidth, function (props) {
  return props.background;
}, progressStyles, progressStyles, function (props) {
  return props.background;
});

var thumbStyles = function thumbStyles(_a) {
  var color = _a.color,
      size = _a.size;
  return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  appearance: none;\n  cursor: grab;\n"], ["\n  background-color: ", ";\n  height: ", "px;\n  width: ", "px;\n  appearance: none;\n  cursor: grab;\n"])), color, size, size / 2);
};

var rangeStyles = /*#__PURE__*/css(templateObject_6 || (templateObject_6 = /*#__PURE__*/__makeTemplateObject(["\n  ", "\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  appearance: none;\n"], ["\n  ", "\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  appearance: none;\n"])), fullWidth);
var Slider = /*#__PURE__*/styled.input.attrs({
  type: 'range'
})(templateObject_7 || (templateObject_7 = /*#__PURE__*/__makeTemplateObject(["\n  &:focus {\n    outline: none;\n  }\n  ", "\n  &[value]::-moz-range-track {\n    ", "\n  }\n  &[value]::-webkit-slider-thumb {\n    ", "\n  }\n  &[value]::-moz-slider-thumb {\n    ", "\n  }\n"], ["\n  &:focus {\n    outline: none;\n  }\n  ", "\n  &[value]::-moz-range-track {\n    ", "\n  }\n  &[value]::-webkit-slider-thumb {\n    ", "\n  }\n  &[value]::-moz-slider-thumb {\n    ", "\n  }\n"])), rangeStyles, rangeStyles, thumbStyles, thumbStyles);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;

function Time(_a) {
  var className = _a.className,
      value = _a.value;
  return createElement("div", {
    className: className
  }, secondsToHHMMSS(value));
}

function secondsToHHMMSS(t) {
  if (t === undefined || isNaN(t)) return '-:--';
  var h = Math.floor(t / 3600);
  var m = Math.floor(t / 60) % 60;
  var s = Math.floor(t % 60);
  return "" + (h ? h + ':' : '') + (h ? ('0' + m).slice(-2) : m) + ":" + ('0' + s).slice(-2);
}

function useListener(element, eventName, listener) {
  var savedListener = useRef();
  useEffect(function () {
    savedListener.current = listener;
  }, [listener]);
  useEffect(function () {
    var eventListener = function eventListener(event) {
      return savedListener.current && savedListener.current(event);
    };

    if (element.current) {
      element.current.addEventListener(eventName, eventListener);
    }

    return function () {
      if (element.current) {
        element.current.removeEventListener(eventName, eventListener);
      }
    };
  }, [eventName, element.current]);
}

function useListeners(element, listeners) {
  Object.keys(listeners).forEach(function (eventName) {
    return useListener(element, eventName, listeners[eventName]);
  });
}

function preventDefault(fn) {
  return function (event) {
    event.preventDefault();
    fn();
  };
}

function useAudioPlayer() {
  var _a = useState(false),
      playing = _a[0],
      setPlaying = _a[1];

  var _b = useState(),
      duration = _b[0],
      setDuration = _b[1];

  var _c = useState(0),
      time = _c[0],
      setTime = _c[1];

  var player = useRef(null);

  var updateDuration = function updateDuration() {
    return setDuration(player.current ? player.current.duration : undefined);
  };

  var updateTime = function updateTime() {
    return setTime(player.current ? player.current.currentTime : 0);
  };

  useListeners(player, {
    play: function play() {
      return setPlaying(true);
    },
    pause: function pause() {
      return setPlaying(false);
    },
    ended: function ended() {
      return setPlaying(false);
    },
    durationchange: updateDuration,
    seeked: updateTime,
    timeupdate: updateTime,
    loadedmetadata: updateDuration
  });
  return {
    playerRef: player,
    playing: playing,
    time: time,
    duration: duration,
    play: preventDefault(function () {
      return player.current && player.current.play();
    }),
    pause: preventDefault(function () {
      return player.current && player.current.pause();
    }),
    seek: function seek(time) {
      return player.current && (player.current.currentTime = time < 0 ? 0 : Math.min(time, player.current.duration));
    },
    skipForward: function skipForward(amount) {
      return player.current && (player.current.currentTime = Math.min(player.current.currentTime + amount, player.current.duration));
    },
    skipBack: function skipBack(amount) {
      return player.current && (player.current.currentTime = Math.max(player.current.currentTime - amount, 0));
    }
  };
}

var canonicalWidth = 750;
var canonicalHeight = 225;
var aspectRatio = canonicalWidth / canonicalHeight;

function AudioCard(_a) {
  var art = _a.art,
      autoPlay = _a.autoPlay,
      background = _a.background,
      className = _a.className,
      _b = _a.color,
      color = _b === void 0 ? '#666' : _b,
      link = _a.link,
      linkText = _a.linkText,
      _c = _a.preload,
      preload = _c === void 0 ? 'none' : _c,
      _d = _a.progressBarBackground,
      progressBarBackground = _d === void 0 ? '#ddd' : _d,
      _e = _a.progressBarCompleteBackground,
      progressBarCompleteBackground = _e === void 0 ? '#aaa' : _e,
      skipBackSeconds = _a.skipBackSeconds,
      skipForwardSeconds = _a.skipForwardSeconds,
      source = _a.source,
      title = _a.title;

  var _f = useAudioPlayer(),
      playerRef = _f.playerRef,
      playing = _f.playing,
      time = _f.time,
      duration = _f.duration,
      play = _f.play,
      pause = _f.pause,
      seek = _f.seek,
      skipForward = _f.skipForward,
      skipBack = _f.skipBack;

  var _g = useDimensions(),
      ref = _g[0],
      width = _g[1].width;

  var height = width / aspectRatio;

  var h = function h(value) {
    return value * height / canonicalHeight;
  };

  var w = function w(value) {
    return value * width / canonicalWidth;
  };

  return createElement(Container$1, {
    className: className,
    ref: ref,
    background: background,
    color: color,
    style: {
      height: height
    }
  }, createElement("audio", {
    src: source,
    ref: playerRef,
    style: {
      display: 'none'
    },
    preload: preload,
    autoPlay: autoPlay
  }), art && createElement(Art, {
    src: art,
    style: {
      height: height,
      width: height,
      minHeight: height,
      minWidth: height
    }
  }), createElement(Content, null, title && createElement(Title, {
    style: {
      fontSize: h(24),
      width: w(canonicalWidth - (art ? canonicalHeight : 0) - 20),
      margin: h(12) + "px " + w(10) + "px " + h(12) + "px " + w(10) + "px",
      minHeight: h(30)
    }
  }, title), createElement(Controls, {
    style: {
      fontSize: h(16)
    }
  }, skipBackSeconds === undefined ? createElement(Control, {
    as: "div"
  }) : createElement(Control, {
    onClick: preventDefault(function () {
      return skipBack(skipBackSeconds);
    })
  }, createElement(SkipBack, {
    seconds: skipBackSeconds
  })), !playing && createElement(Control, {
    onClick: play
  }, createElement(Play, null)), playing && createElement(Control, {
    onClick: pause
  }, createElement(Pause, null)), skipForwardSeconds === undefined ? createElement(Control, {
    as: "div"
  }) : createElement(Control, {
    onClick: preventDefault(function () {
      return skipForward(skipForwardSeconds);
    })
  }, createElement(SkipForward, {
    seconds: skipForwardSeconds
  }))), link && linkText && createElement(Link, {
    href: link,
    style: {
      fontSize: h(20)
    }
  }, linkText), createElement(Times, {
    style: {
      fontSize: h(16)
    }
  }, createElement(Time, {
    value: time
  }), createElement(Time, {
    value: duration
  })), createElement(ProgressBar, {
    value: time,
    total: duration,
    color: color,
    background: progressBarBackground,
    completeBackground: progressBarCompleteBackground,
    seek: seek,
    size: h(20)
  })));
}

var Container$1 = /*#__PURE__*/styled.div(templateObject_1$1 || (templateObject_1$1 = /*#__PURE__*/__makeTemplateObject(["\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  * {\n    font-family: 'San Francisco', 'Helvetica Neue', Helvetica, sans-serif;\n    line-height: 1em;\n  }\n  ", "\n  color: ", ";\n  a {\n    color: ", ";\n    text-decoration: none;\n    &:active {\n      color: ", ";\n    }\n  }\n"], ["\n  width: 100%;\n  max-width: 100%;\n  display: flex;\n  flex-flow: row nowrap;\n  * {\n    font-family: 'San Francisco', 'Helvetica Neue', Helvetica, sans-serif;\n    line-height: 1em;\n  }\n  ", "\n  color: ", ";\n  a {\n    color: ", ";\n    text-decoration: none;\n    &:active {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
  var background = _a.background;
  return background && "background-color: " + background + ";";
}, function (_a) {
  var color = _a.color;
  return color;
}, function (_a) {
  var color = _a.color;
  return color;
}, function (_a) {
  var color = _a.color;
  return color;
});
var Content = /*#__PURE__*/styled.div(templateObject_2$1 || (templateObject_2$1 = /*#__PURE__*/__makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-flow: column nowrap;\n  padding: 0;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-flow: column nowrap;\n  padding: 0;\n"])));
var Controls = /*#__PURE__*/styled.div(templateObject_3$1 || (templateObject_3$1 = /*#__PURE__*/__makeTemplateObject(["\n  flex: 1;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n"], ["\n  flex: 1;\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n"])));
var Times = /*#__PURE__*/styled.div(templateObject_4$1 || (templateObject_4$1 = /*#__PURE__*/__makeTemplateObject(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  margin: 0 5px 5px 5px;\n"], ["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  margin: 0 5px 5px 5px;\n"])));
var Control = /*#__PURE__*/styled.a.attrs({
  href: '#'
})(templateObject_5$1 || (templateObject_5$1 = /*#__PURE__*/__makeTemplateObject(["\n  text-decoration: none;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  margin: 5px;\n  width: 15%;\n"], ["\n  text-decoration: none;\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  margin: 5px;\n  width: 15%;\n"])));
var Art = /*#__PURE__*/styled.img(templateObject_6$1 || (templateObject_6$1 = /*#__PURE__*/__makeTemplateObject([""], [""])));
var Title = /*#__PURE__*/styled.div(templateObject_7$1 || (templateObject_7$1 = /*#__PURE__*/__makeTemplateObject(["\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"], ["\n  text-align: center;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"])));
var Link = /*#__PURE__*/styled.a.attrs({
  target: '_blank'
})(templateObject_8 || (templateObject_8 = /*#__PURE__*/__makeTemplateObject(["\n  display: block;\n  text-align: center;\n  &:hover {\n    text-decoration: underline;\n  }\n"], ["\n  display: block;\n  text-align: center;\n  &:hover {\n    text-decoration: underline;\n  }\n"])));
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8;
export default AudioCard;